var map = {
	"./de/impressum.mdx": 66981,
	"./de/index.mdx": 13288,
	"./de/rechtliche-grundlagen.mdx": 9555,
	"./en/imprint.mdx": 9787,
	"./en/index.mdx": 9900,
	"./en/legal-framework.mdx": 80212,
	"./fr/cadre-juridique.mdx": 96741,
	"./fr/impressum.mdx": 21368,
	"./fr/index.mdx": 94921,
	"./it/colophon.mdx": 38560,
	"./it/index.mdx": 80350,
	"./it/quadro-giuridico.mdx": 45508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 64504;
module.exports = webpackContext;